import styled, { css } from "styled-components"

export const Ul = styled.ul`
  margin: 0;

  ${({ profileData }) =>
    profileData &&
    css`
      padding-left: 16px;
      padding-top: 4px;
    `}
`

export const Li = styled.li`
  color: ${({ theme }) => theme.colors.content.text};
  font-family: ${({ theme }) => theme.fonts.body.family}, sans-serif;
  font-weight: ${({ theme }) => theme.fonts.body.weight};
  margin-bottom: 0.25rem;

  ${({ profileData }) =>
    profileData &&
    css`
      color: #333333;
      font-weight: 500;
      font-size: 16px;
      font-weight: normal;
    `}

  &:last-child {
    margin-bottom: 0;
  }
`
